import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {ImageOptimized} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {SwiperSlide} from 'swiper/react';
import {Banner as BannerType} from '@/__generated__/__types__';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

interface CategoryBannerSwiperProps {
    readonly categoryId: number;
    readonly categoryBanners?: BannerType[];
}

// Now, just a simple component to display a list of banners from server
function CategoryBannerSwiper({categoryBanners: categoryBanners}: CategoryBannerSwiperProps) {
    if (!categoryBanners || categoryBanners?.length === 0) {
        return <></>;
    }
    return (
        <CustomSwiper
            className="mt-5 overflow-hidden! rounded-[1.25rem]"
            spaceBetween={20}
            hasNavigation
            autoplay={false}
            buttonPrevClassName="-left-4"
            buttonNextClassName="-right-4"
            loop={true}>
            {categoryBanners?.map((item, index) => {
                return (
                    <>
                        {item?.image && (
                            <SwiperSlide key={item?.banner_id}>
                                <Link href={item?.url_banner ?? 'javascript:;'}>
                                    <div className="relative">
                                        <ImageOptimized
                                            src={getBannerUrlByPath(item?.image)}
                                            alt="Banner"
                                            width={index > 0 ? 1204 : 1205}
                                            height={index > 0 ? 250 : 251}
                                            className="h-full w-full object-cover"
                                            loading={index > 0 ? 'lazy' : 'eager'}
                                        />
                                    </div>
                                </Link>
                            </SwiperSlide>
                        )}
                    </>
                );
            })}
        </CustomSwiper>
    );
}

export default CategoryBannerSwiper;
